function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    phone\n  ");

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "phone_svg__phone_svg__st0",
  d: "M6.9,0.8H18c1.9,0,3.4,1.5,3.4,3.4v23.4c0,1.9-1.5,3.4-3.4,3.4H6.9c-1.9,0-3.4-1.5-3.4-3.4V4.1 C3.6,2.3,5.1,0.8,6.9,0.8z",
  fill: "none",
  stroke: "#717375",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  className: "phone_svg__phone_svg__st1",
  cx: 12.5,
  cy: 27.7,
  r: 1.2,
  fill: "#717375"
}), /*#__PURE__*/React.createElement("line", {
  className: "phone_svg__phone_svg__st0",
  x1: 3.6,
  y1: 24.6,
  x2: 21.4,
  y2: 24.6,
  fill: "none",
  stroke: "#717375",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  className: "phone_svg__phone_svg__st0",
  x1: 3.6,
  y1: 6.1,
  x2: 21.4,
  y2: 6.1,
  fill: "none",
  stroke: "#717375",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  className: "phone_svg__phone_svg__st0",
  x1: 9.9,
  y1: 3.6,
  x2: 15.1,
  y2: 3.6,
  fill: "none",
  stroke: "#717375",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31.6,
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 31.6",
    style: {
      enableBackground: "new 0 0 25 31.6"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
}

export default SvgPhone;